const enDirectoryBrowse: Record<
  string,
  { message: string; description: string }
> = {
  "ledgerEditor.cloneRepository": {
    message: "Clone Repository",
    description: "Header for clone repository dialog",
  },
  "ledgerEditor.downloadZip": {
    message: "Download ZIP",
    description: "Menu item to download as ZIP",
  },
  "ledgerEditor.manageSshKeys": {
    message: "Manage SSH Keys",
    description: "Menu item for SSH key management",
  },
  "ledgerEditor.thisDirectoryIsEmpty": {
    message: "This directory is empty",
    description: "Message shown when directory has no contents",
  },
};

export default enDirectoryBrowse;
